// `ng build` replaces `environment.ts` with `environment.development.ts`.

const localhostUrl = "https://localhost:44351/api";

export const appLocalEnviroment = {
    authUrlId: "78339df7-55fe-4b29-9ceb-13e364c1c9fc",
    clientId: "fd2c0313-84c8-4ef9-828c-0c9932fc8b85",
    clientSecret: "-ZS8Q~piPXsyJMVXHzaAffnJFoye9cQ_aMXuxcS9",
    scope: "https://softvaerket-dev.crm4.dynamics.com/.default",
    grantType: "client_credentials",
    apiUrl: "https://softvaerket-dev.crm4.dynamics.com/api/data/v9.2/"
};

export const environment = {
    production: false,
    apiUrl: localhostUrl,
    tokenServer: "https://svk-supp-sys-dev-tokenserver-app.azurewebsites.net",
    msalConfig: {
        auth: {
            clientId: "bd8314b4-75dc-4c5d-86de-7c663c85b763"
        }
    },
    apiConfig: {
        scopes: [""],
        uri: ""
    },
    b2cPolicies: {
        names: {
            signIn: "B2C_1_si",
            signUpSignIn: "B2C_1_susi",
            resetPassword: "B2C_1_password_reset",
            editProfile: "B2C_1_profile_edit"
        },
        authorities: {
            signIn: {
                authority: "https://devsupportsystemet.b2clogin.com/devsupportsystemet.onmicrosoft.com/"
            },
            signUpSignIn: {
                authority: "https://devsupportsystemet.b2clogin.com/devsupportsystemet.onmicrosoft.com/B2C_1_SupportSystem_SigninSignup"
            },
            resetPassword: {
                authority: "https://devsupportsystemet.b2clogin.com/devsupportsystemet.onmicrosoft.com//B2C_1_SupportSystem_PasswordReset"
            },
            editProfile: {
                authority: "https://devsupportsystemet.b2clogin.com/devsupportsystemet.onmicrosoft.com//B2C_1_SupportSystem_Edit"
            }
        },
        authorityDomain: "devsupportsystemet.b2clogin.com"
    },
    matomoSettings: {
        siteId: 1891,
        trackerUrl: "//matomo.eforsyning.dk/"
    }
};
